// Random ids of the client. It is a leaf with no import.

/** `n` random bytes as lower-case hex, two digits a byte. The device id,
 *  the tab id of `connection.ts` and the session id of `faultreport.ts`
 *  are made of it. */
export function randomHex(n: number): string {
  const bytes = new Uint8Array(n);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
